import React, { useContext } from 'react';
import { ActionType, parseDonateActions } from '../donate-form-utils';
import { DonateFormContext } from '../DonateFormContext';
import CreditCardDonation from './CreditCardDonation';
import DigitalWalletButton from './DigitalWalletButton';
import PayPalButton from './PayPalButton';
import PledgeDonation from './PledgeDonation';

const donateFormActions = document.querySelectorAll('#donate-form-actions a');

const DonateFormActions = () => {
    const { config } = useContext(DonateFormContext);
    const { isAppleGooglePayEnabled, isPayPalEnabled } = config;
    const actions = parseDonateActions(donateFormActions);

    return (
        <div className="layout-grouping-children layout-grouping-children--tiny">
            {actions[ActionType.CreditCard] && <CreditCardDonation action={actions[ActionType.CreditCard]!} />}
            {isPayPalEnabled && <PayPalButton />}
            {isAppleGooglePayEnabled && <DigitalWalletButton />}
            {actions[ActionType.Pledge] && <PledgeDonation action={actions[ActionType.Pledge]!} />}
        </div>
    );
}

export default DonateFormActions;
